import {IDS} from '../requirements-assessment-action-id.constants';
import { IDS as MASTER_DOC_LIST_IDS } from '../../master-doc-list/master-doc-list-action-id.constants';
import {TYPES} from "../requirements-assessment-action-type.constants";
import * as EvidenceActions from '../requirements-assessment.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FETCH, GRID_FILTER, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";
import watch from "redux-watch";
import pick from "lodash/pick";
import {TAB_SELECT} from "../../../../common/tabs/tabs.constants";
import find from "lodash/find";
import {TYPES as RCO_TYPES} from "../../accreditation-action-type.constants";
import {fetchAutocompleteUser} from "../../accreditation.actions";

class EvidenceGroupImprovementController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $filter,
                $timeout,
                $transitions,
                $mdDialog,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoRequirementsAssessment;
        this.$scope = $scope;
    }

    $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        const user = this.AuthService.getUser();
        this.userUuid = user.uuid;
        this.userName = user.name;
        this.isAdmin = user.type === 'Administrator';

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation.rcoRequirementsAssessment;
            const details = subModule.evidenceDetails;
            const requirement = state.accreditation.selectedRequirement;
            // this.maxDueDate = moment(`${maxYear}-01-01`).add(fiscalYearStart, 'months').subtract(1,'days').toDate();
            this.minDueDate = new Date();

            return {
                details,
                requirementName: requirement?.name,
                requirementDescription: get(requirement, 'description', '')?.replace(/\n/g, '<br>'),
                fiscalYear: accDashboardLocationYear.year,
                locationName: subModule.selectedSiteLocation?.locationName,
                siteLocationUuid: subModule.selectedSiteLocation?.uuid,
                headOfficeUuid: subModule.selectedHeadOffice?.uuid,
                requirement,
                selectedAuditTask: this.isAdmin
                    ? subModule.selectedAuditTask
                    : subModule.auditors?.find(item => item.assignee_uuid === this.userUuid)?.uta_id,
                documentForRevisionRequest: subModule.documentForRevisionRequest,
                docRevisionRequest: subModule.docRevisionRequest,
                improvementAction: subModule.improvementAction,
                improvementSteps: get(subModule, `${IDS.rcoEvidenceGroupImprovementStepsGrid}.items`, []),
                improvementStep: subModule.improvementStep,
            }
        }, {
            ...AccAction,
            ...EvidenceActions,
            ...this.FileActions,
        })(this);

        const ctrl = this;
        this.$timeout(function() {
            ctrl.fetchAutocompleteUser(
                ctrl.userUuid,
                `${ctrl.identifier}.${IDS.rcoEvidenceDocRevisionCandidates}`,
                `${ctrl.identifier}.improvementAction`
            );
            ctrl.$ngRedux.dispatch({
                id: ctrl.identifier,
                type: TYPES.SET_IMPROVEMENT_STEP_DETAILS,
                details: {},
                firstDocType: ctrl.firstDocType
            });
            ctrl.$ngRedux.dispatch({
                id: ctrl.identifier,
                type: GRID_FETCH,
                path: IDS.rcoEvidenceGroupImprovementStepsGrid,
                items: [],
            })
        }, 200);
    }

    async onAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.siteLocationUuid,
            `${this.identifier}.${IDS.rcoEvidenceDocRevisionCandidates}`,
        );
    }

    onAddImprovementStep = () => {
        // verify limit of 100 steps is not reached
        if (this.improvementSteps.length === 100)
            return

        // verify fields
        if(!this.$scope.evgActionStepForm.$valid) {
            this.Notifier.error('Please fill in the form fields');
            return;
        }

        // verify that title is unique
        if(this.improvementSteps.some(step => step.title === this.improvementStep.title)) {
            this.Notifier.error('Action task title already exists');
            return;
        }

        this.$ngRedux.dispatch({
            type: GRID_FETCH,
            id: this.identifier,
            path: IDS.rcoEvidenceGroupImprovementStepsGrid,
            items: [
                {
                    ...this.improvementStep,
                    requirement_id: this.requirement?.id,
                    evidence_id: this.details.ard_id,
                },
                ...this.improvementSteps
            ],
        });
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.SET_IMPROVEMENT_STEP_DETAILS,
            details: {
                title: null,
                description: '',
                assignee: null,
                due_date: null,
            },
            firstDocType: this.firstDocType,
        });
        this.$scope.evgActionStepForm.$setPristine();
        this.$scope.evgActionStepForm.$setUntouched();
    }

    onGridButtonRemoveTask = ({item}) => {
        this.$ngRedux.dispatch({
            type: GRID_FETCH,
            id: this.identifier,
            path: IDS.rcoEvidenceGroupImprovementStepsGrid,
            items: [...this.improvementSteps.filter(step => step !== item)]
        })
    }

    // onSelectImprovementStep = ({item}) => {
    //     this.$ngRedux.dispatch({
    //         id: this.identifier,
    //         type: TYPES.SET_IMPROVEMENT_STEP_DIALOG,
    //         details: item
    //     });
    //     const dialogController = ($scope) => {
    //         $scope.identifier = this.identifier;
    //         $scope.onAutocompleteKeywordQuery = async (event) => await this.onAutocompleteKeywordQuery(event);
    //         $scope.submit = () => {
    //             if ($scope.improvementStepDialogForm.$valid) {
    //                 this.$ngRedux.dispatch({
    //                     id: $scope.identifier,
    //                     type: TYPES.UPDATE_IMPROVEMENT_STEP,
    //                 });
    //                 this.$mdDialog.hide();
    //             }
    //         };
    //         $scope.cancel = () => {
    //             this.$mdDialog.cancel();
    //         };
    //     };
    //     dialogController.$inject = ['$scope'];
    //
    //     this.dialog = this.$mdDialog.show({
    //         controller: dialogController,
    //         template: require('./evidence-group-improvement-step-dialog.html'),
    //         parent: angular.element(document.body),
    //         clickOutsideToClose: true
    //     }).then(this.resetImprovementStepDialog, this.resetImprovementStepDialog);
    // }

    // resetImprovementStepDialog = () => {
    //     this.$ngRedux.dispatch({
    //         id: this.identifier,
    //         type: TYPES.SET_IMPROVEMENT_STEP_DIALOG,
    //         details: {}
    //     });
    // };


    onSubmit() {
        const form = this.$scope.evgImprovementActionForm;
        if(form.$invalid) {
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            for (const item of form.$$controls) {
                if (item.$invalid) {
                    item.$setTouched();
                }
            }
            return;
        }

        if(!this.improvementSteps?.length) {
            this.Notifier.error('Please add at least one task');
            return;
        }

        this.addImprovementAction({
            vdo_uuid: this.documentForRevisionRequest?.id || this.details?.vdo_uuid,
            framework:          this.schemeCode,
            slo_uuid:           this.siteLocationUuid,
            audit_task:         this.selectedAuditTask,
            assignee:           this.improvementAction?.assignee.subject_uuid,
            title:              this.improvementAction?.title,
            description:        this.improvementAction?.description,
            due_date:           formatDate(this.improvementAction?.dueDate, DATE_FORMAT.OUTPUT),
            action_steps:       this.improvementSteps.map(step => ({
                assignee:       step.assignee.subject_uuid,
                title:          step.title,
                description:    step.description,
                requirement_id: step.requirement_id,
                evidence_id:    step.evidence_id,
                due_date:       formatDate(step.due_date, DATE_FORMAT.OUTPUT),
            })),
        }).then(() => {
            // this.$ngRedux.dispatch({
            //     type: TAB_SELECT,
            //     id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            //     state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
            // });

            this.$ngRedux.dispatch({
                type: GRID_FETCH,
                id: this.identifier,
                path: IDS.rcoEvidenceGroupImprovementStepsGrid,
                items: [],
            });
            this.$ngRedux.dispatch({
                id: this.identifier,
                type: TYPES.SET_IMPROVEMENT_ACTION_DETAILS,
                details: {}
            });
            form.$setPristine();
            form.$setUntouched();
        });
    }

    onCancel() {
        this.$ngRedux.dispatch({
            type: TAB_SELECT,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
        });
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();
    }
}

EvidenceGroupImprovementController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$filter',
    '$timeout',
    '$transitions',
    '$mdDialog',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions',
    '$scope']

export const evidenceGroupImprovement = {
    controller: EvidenceGroupImprovementController,
    template: `
    <div class="formHeader" layout-align="start center" style="margin-left: 20px;" flex>
        <h4>
            <div layout="row" layout-align="start center">
                <asset cls="colorAccreditations" src="rco-requirement.svg"></asset>
                <div style="padding-left: 5px;">{{$ctrl.requirementName}}</div>
            </div>
        </h4>
    </div>
    <div hide-md hide-sm hide-xs > </div>
    <div style="padding-left: 20px;">Requirement: {{$ctrl.requirementDescription}}
        <md-tooltip ng-if="$ctrl.filenameTooltip">{{$ctrl.filenameTooltip}}</md-tooltip>
    </div>
    <div layout="row" flex style="margin: 20px">
        <div layout-gt-xs="column" style="min-width:150px">
            <div class="accreditation-table-item md-body-1">{{'COMMON.FIELD.SITE_LOCATION' | translate}}:</div>
            <div class="accreditation-table-item md-body-1" ng-if="$ctrl.fiscalYear">{{'COMMON.DATE.FISCAL_YEAR' | translate}}:</div>
        </div>
        <span flex="5"></span>
        <div layout-gt-xs="column">
            <div class="accreditation-table-item md-body-1">{{$ctrl.locationName}}</div>
            <div class="accreditation-table-item md-body-1" ng-if="$ctrl.fiscalYear">{{$ctrl.fiscalYear}}</div>
        </div>
    </div>
    
    <div class="formHeader"  layout-align="start center" flex>
        <h4>
            <div layout="row" layout-align="start center" style="padding: 0 20px;">
                <asset cls="colorAccreditations" style="padding-right: 10px; scale:60%" src="rco-evidence-icon.svg"></asset>
                <div>{{$ctrl.details.doc_num}} - {{$ctrl.details.name}}</div>
                <div flex></div>
                <div><span>Status:</span> <span ng-style="{'color':$ctrl.evidenceStatusColor}">{{$ctrl.details.status_name}}</span></div>
            </div>
        </h4>
    </div>
    <div layout="row" flex style="margin: 20px">
        <p flex ng-bind-html="['Evidence: ' + ($ctrl.details.description || '...')].join(' ')"></p>
    </div>

    <h4>
        <div style="padding-left: 20px;">{{'ACCREDITATION.REQUIREMENTS.EVIDENCE_OWNER' | translate}}{{!$ctrl.details.review_task_id ? ' Is Not Set' : ''}}</div>
    </h4>
    <div layout="row" flex style="margin: 20px" ng-if="$ctrl.details.review_task_id">
        <div layout-gt-xs="column" style="min-width:150px">
            <div class="accreditation-table-item md-body-1">Assignee:</div>
            <div class="accreditation-table-item md-body-1">Status:</div>
            <div class="accreditation-table-item md-body-1">Due Date:</div>
            <div class="accreditation-table-item md-body-1">Created By:</div>
            <div class="accreditation-table-item md-body-1">Created At:</div>
        </div>
        <span flex="5"></span>
        <div layout-gt-xs="column">
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_assignee}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_status_name}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_due_date}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_created_by}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_created_at}}</div>
        </div>
    </div>
    <div layout-margin></div>
    <md-divider></md-divider>
    <div>
        <div style="margin: 10px 0 5px 0;">
            <h3>
                <div layout="row" layout-align="start center">
                    <div style="padding-left: 5px;">Assign Improvement Action</div>
                </div>
            </h3>
            <md-subheader class="md-no-sticky">Improvement Action</md-subheader>
        </div>
        <div layout="row" flex style="margin: 0 20px 10px 20px">
            <div layout-gt-xs="column" style="min-width:200px">
                <div class="accreditation-table-item md-body-1">Source:</div>
                <div class="accreditation-table-item md-body-1">Linked requirement:</div>
                <div class="accreditation-table-item md-body-1">Linked document:</div>
                <div class="accreditation-table-item md-body-1">Type:</div>
            </div>
            <span flex="5"></span>
            <div layout-gt-xs="column">
                <div class="accreditation-table-item md-body-1">Document Revision Request</div>
                <div class="accreditation-table-item md-body-1">{{$ctrl.requirementName || '-'}}</div>
                <div class="accreditation-table-item md-body-1">{{($ctrl.documentForRevisionRequest && $ctrl.documentForRevisionRequest.name) || $ctrl.details.name || '-'}}</div>
                <div class="accreditation-table-item md-body-1">Corrective</div>
            </div>
        </div>
        <div layout="column" class="eventsTransparent" style="margin-bottom: 40px;">
            <h4>Improvement Action Details</h4>
            <ng-form name="evgImprovementActionForm" style="margin: 10px" >
                <div layout="row">
<!--                    <md-subheader class="md-no-sticky" style="margin-top: 20px">Improvement assignee</md-subheader>-->
                    <asset cls="input-icon" style="margin-top: 18px" src="user.svg"></asset>
                    <autocomplete flex
                                  name="actionAssigneeAutocomplete"
                                  label="Approver Of Action Tasks"
                                  identifier="{{$ctrl.identifier}}"
                                  action="$ctrl.onAutocompleteKeywordQuery($event)"
                                  state-provider="rcoEvidenceDocRevisionCandidates"
                                  state-path="improvementAction.assignee"
                                  validate="true"
                                  required="true"
                                  item-icon="user.svg"
                                  item-props="['name']">
                    </autocomplete>
                </div>
                <div layout-gt-xs="row">
                    <asset cls="input-icon" style="margin-top: 18px" src="action-task.svg"></asset>
                    <input-text flex
                                class="noMarginBottom"
                                name="improvementTitle"
                                label="Title (improvement intent)"
                                identifier="{{$ctrl.identifier}}"
                                state-path="improvementAction.title"
                                required="true"
                                max-length="120">
                    </input-text>
                </div>
                <div layout-gt-xs="row">
                    <input-text-area flex
                                     class="noMarginBottom"
                                     name="improvementRootCause"
                                     rows="3"
                                     label="Description (Root Cause)"
                                     identifier="{{$ctrl.identifier}}"
                                     state-path="improvementAction.description"
                                     required="true"
                                     max-length="1000">
                    </input-text-area>
                </div>
                <div layout-gt-md="row">
                    <input-date name="improvementDueDate"
                                flex-gt-md="20"
                                class="noMarginBottom"
                                label="Improvement Due Date"
                                identifier="{{$ctrl.identifier}}"
                                state-path="improvementAction.dueDate"
                                min-date="$ctrl.minDueDate"
                                max-date="$ctrl.maxDueDate"
                                validate="true"
                                required="true">
                    </input-date>
                </div>
            </ng-form>
        </div>
        
        <div layout-margin></div>
        <div layout="column" class="eventsTransparent" style="margin-bottom: 40px;">
            <ng-form name="evgActionStepForm">
                <h4>Add Action Task</h4>
                <div layout-gt-xs="row">
                    <div layout="row" flex>
                        <asset cls="input-icon" style="margin-top: 18px" src="action-task.svg"></asset>
                        <input-text flex label="Action Task Title"
                                    class="noMarginBottom"
                                    name="action_task_title"
                                    max-length="120"
                                    identifier="{{$ctrl.identifier}}"
                                    state-path="improvementStep.title"
                                    validate="true"
                                    required="true">
                        </input-text>
                    </div>
<!--                            <input-text flex-gt-sm="20"-->
<!--                                        class="noMarginBottom"-->
<!--                                        name="action_task_id"-->
<!--                                        label="Action Task ID No."-->
<!--                                        identifier="{{$ctrl.identifier}}"-->
<!--                                        state-path="action_task_print_id"-->
<!--                                        disabled="true">-->
<!--                            </input-text>-->
                </div>
                <div layout-gt-xs="row">
                    <input-text-area flex
                                     class="noMarginBottom"
                                     name="action_task_description"
                                     rows="3"
                                     max-length="1000"
                                     label="Details of Action Task"
                                     identifier="{{$ctrl.identifier}}"
                                     state-path="improvementStep.description"
                                     validate="true"
                                     required="true">
                    </input-text-area>
                </div>
                <div layout-gt-xs="row">
                    <asset cls="input-icon" style="margin-top: 18px" src="user.svg"></asset>
                    <autocomplete flex
                                  name="assigneeCandidateAutocomplete"
                                  label="Action Task Assignee"
                                  identifier="{{$ctrl.identifier}}"
                                  action="$ctrl.onAutocompleteKeywordQuery($event)"
                                  state-provider="rcoEvidenceDocRevisionCandidates"
                                  state-path="improvementStep.assignee"
                                  validate="true"
                                  required="true"
                                  item-icon="user.svg"
                                  item-props="['name']">
                    </autocomplete>
                    <input-date name="action_task_date"
                                class="noMarginBottom"
                                label="Due Date"
                                identifier="{{$ctrl.identifier}}"
                                state-path="improvementStep.due_date"
                                min-date="$ctrl.minDueDate"
                                max-date="$ctrl.maxDueDate"
                                validate="true"
                                required="true">
                    </input-date>
                </div>
                <div layout-xs="column" layout-sm="column" layout-gt-sm="row" flex layout-align="center center">
<!--                            <input-checkbox module="events"-->
<!--                                            identifier="{{$ctrl.identifier}}"-->
<!--                                            state-path="save_task_to_library"-->
<!--                                            label="Save to Action Task Library">-->
<!--                            </input-checkbox>-->
                    <div flex hide-xs hide-sm></div>
<!--                            <md-button class="btnDefault" name="btnActionTaskLibrary" aria-label="Action Task Library" ng-click="$ctrl.openActionTaskLibrary()">-->
<!--                                Action Task Library-->
<!--                            </md-button>-->
<!--                            <md-button class="btnDefault" name="btnActionTask" aria-label="Preselect Action Task" ng-click="$ctrl.selectActionTask()">-->
<!--                                Preselect Action Task-->
<!--                            </md-button>-->
                    <md-button
                        class="btnDefault btnColorAccreditations"
                        name="btnAddActionTask"
                        aria-label="Add Action Task"
                        ng-click="$ctrl.onAddImprovementStep()">Add Action Task
                    </md-button>
                </div>
            </ng-form>
        </div>
<!--            <div style="margin: 10px 0 5px 0;">-->
<!--                <h4>-->
<!--                    <div layout="row" layout-align="start center">-->
<!--                        <div style="padding-left: 5px;">Action Plan</div>-->
<!--                    </div>-->
<!--                </h4>-->
<!--            </div>-->
        <evidence-group-improvement-steps-grid
            on-remove="$ctrl.onGridButtonRemoveTask($event)">
        </evidence-group-improvement-steps-grid>
        <div layout-xs="column" layout-gt-xs="row" layout-align="center center" class="tabs">
            <div flex></div>
            <md-button class="btnTabsNav"
                       name="cancel"
                       aria-label="Cancel"
                       ng-click="$ctrl.onCancel()">
                <asset src="arrow_left.svg"></asset>BACK
            </md-button>
            <button type="submit"
                    class="md-button btnColorAccreditations"
                    aria-label="Request Document Revision"
                    ng-disabled="!$ctrl.improvementSteps.length || evgImprovementActionForm.$invalid"
                    ng-click="$ctrl.onSubmit()">Submit Improvement
            </button>
        </div>
    </div>
    `
}
